import { z } from 'zod';
import { zSearchText } from '@/shared/lib/search';

/** Base URL search schema for every DataWorkspace route. Extend with the page's filter keys. */
export const workspaceSearchSchema = z.object({
  q: zSearchText(),
  sort: zSearchText(),
  page: z.coerce.number().int().min(1).optional(),
  size: z.coerce.number().int().min(1).max(100).optional(),
  view: zSearchText(),
  cols: zSearchText(),
  order: zSearchText(),
  peek: zSearchText(),
});
